import React from 'react'
type propsSide = {
    isActive: boolean,
    [key: string]: unknown;
}

export const SideB = ({ isActive, ...props }: propsSide) => {
    let colorSide: string = `#EDEAE2`
    if (isActive) colorSide = `#425D76`

    let colorText: string = `#BBB5AA`
    if (isActive) colorText = `#040503`
   
    return (
        <svg width="77" height="83" viewBox="0 0 77 83" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M76 50.4083L61.1293 65.8083H1V31.8L15.8707 16.4L45.2888 1L76 16.4V50.4083Z" fill="white" />
            <path d="M76 16.3999L61.1293 32.1207V65.8082L76 50.4082V16.3999Z" fill={colorSide} stroke={colorText} stroke-linejoin="round" />
            <path d="M1 65.8082V31.8068L30.4181 16.3999L61.1293 31.8068V65.8082H1Z" stroke={colorText} />
            <path d="M15.8707 50.4083V16.4069L45.2888 1L76 16.4069V50.4083H15.8707Z" stroke={colorText} />
            <path d="M15.8707 16.3999L1 31.7999V65.8082L15.8707 50.4082V16.3999Z" stroke={colorText} stroke-linejoin="round" />
            <path d="M30.4181 16.4L45.6121 1" stroke={colorText} />
            <path d="M36.505 82.8083V72.1443H39.9913C41.1486 72.1443 42.0177 72.3835 42.5988 72.8621C43.1847 73.3406 43.4777 74.0486 43.4777 74.9861C43.4777 75.4841 43.3361 75.926 43.0529 76.3118C42.7697 76.6926 42.3839 76.988 41.8956 77.198C42.4718 77.3591 42.9259 77.6667 43.2579 78.1208C43.5948 78.5701 43.7633 79.1072 43.7633 79.7322C43.7633 80.6892 43.4532 81.4412 42.8331 81.988C42.213 82.5349 41.3365 82.8083 40.2037 82.8083H36.505ZM37.9113 77.8206V81.6584H40.233C40.8873 81.6584 41.4025 81.49 41.7784 81.1531C42.1593 80.8113 42.3497 80.3425 42.3497 79.7468C42.3497 78.4626 41.6515 77.8206 40.255 77.8206H37.9113ZM37.9113 76.6926H40.0353C40.6505 76.6926 41.1412 76.5388 41.5074 76.2312C41.8785 75.9236 42.0641 75.5061 42.0641 74.9788C42.0641 74.3928 41.8932 73.968 41.5514 73.7043C41.2096 73.4358 40.6896 73.3015 39.9913 73.3015H37.9113V76.6926Z" fill={colorText} />
        </svg>

    )
}
